import React from "react";
import {
  GridRow,
  Input,
  Icon,
  InputProps,
} from "@metsooutotec/modes-react-components";

interface SensorCsvInputFieldProps {
  formData: Record<string, string>;
  handleChange: (fieldName: string, value: string) => void;
  onFileUpload: () => void;
  clearCSV: () => void;
  inputCsv: Array<{
    id: string;
    label: string;
    placeholder: string;
  }>;
}

const SensorCsvInputField: React.FC<SensorCsvInputFieldProps> = ({
  formData,
  handleChange,
  onFileUpload,
  clearCSV,
  inputCsv,
}) => {
  function handleClearCSV(e: React.MouseEvent, id: string) {
    e.stopPropagation(); // Stop the click event from propagating
    clearCSV(); // Clear the CSV data
    handleChange(id, ""); // Clear the specific form field based on id
  }

  return (
    <>
      {inputCsv.map((input) => {
        const icons = (
          <>
            {formData[input.id] && (
              <Icon
                className="icon-cross-circle-fill-16"
                onClick={(e: React.MouseEvent<Element, MouseEvent>) =>
                  handleClearCSV(e, input.id)
                }
                style={{ marginRight: "2px" }}
              />
            )}
            <Icon className="icon-upload-16" />
          </>
        );

        const inputProps: InputProps = {
          id: input.id,
          label: input.label,
          placeholder: input.placeholder,
          onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
            handleChange(input.id, e.target.value),
          value: formData[input.id],
          readOnly: true,
          spanning: true,
          onClick: onFileUpload,
          heightClass: "medium",
          icon: icons,
        };

        return (
          <GridRow key={input.id}>
            <Input {...inputProps} />
          </GridRow>
        );
      })}
    </>
  );
};

export default SensorCsvInputField;
